'use client'

import { SalesPipeline } from '@/lib/api/sales'
import { MdAdminPanelSettings, MdLock } from 'react-icons/md'

/**
 * Quem vê o funil — docs/sales-pipeline-distribution.md.
 * Com dona ou perfis: cadeado com a lista no tooltip. Sem nenhum: "Só gestão"
 * (apenas administradores e perfis que veem todos os funis).
 */
export default function PipelineRestrictedBadge({ pipeline }: { pipeline: SalesPipeline }) {
    const roleNames = (pipeline.roleAccess ?? []).map(access => access.role.name)
    const hasOwner = !!(pipeline.owner || pipeline.ownerUserId)

    if (!hasOwner && roleNames.length === 0) {
        return (
            <span
                className="badge badge-sm badge-ghost gap-1"
                title="Visível só para administradores e perfis que veem todos os funis"
            >
                <MdAdminPanelSettings className="text-xs" />
                Só gestão
            </span>
        )
    }

    const title = [
        'Veem este funil:',
        ...(pipeline.owner ? [`Dona: ${pipeline.owner.name}`] : []),
        ...(roleNames.length > 0 ? [`Perfis: ${roleNames.join(', ')}`] : []),
        'Administradores e perfis que veem todos os funis',
    ].join('\n')

    return (
        <span className="badge badge-sm badge-warning badge-outline gap-1" title={title}>
            <MdLock className="text-xs" />
            Restrito
        </span>
    )
}
